// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__m0pAd","button":"styles_button__db2+L"};